import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f466390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "child-booking-info-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title-2" }, "お子様の予約情報を入力してください", -1))
const _hoisted_4 = { class: "child-selection" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "お子様を選択してください", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "お子様の情報")
], -1))
const _hoisted_7 = { class: "grid" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("姓 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_10 = {
  id: "child-first-name-error",
  class: "p-error"
}
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_13 = {
  id: "child-last-name-error",
  class: "p-error"
}
const _hoisted_14 = { class: "grid" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("姓（かな） "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_17 = {
  id: "child-first-name-kana-error",
  class: "p-error"
}
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("名（かな） "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_20 = {
  id: "child-last-name-kana-error",
  class: "p-error"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("性別 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_22 = { class: "flex flex-wrap gap-3" }
const _hoisted_23 = { class: "flex align-items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "child-male",
  class: "ml-2"
}, "男性", -1))
const _hoisted_25 = { class: "flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "child-female",
  class: "ml-2"
}, "女性", -1))
const _hoisted_27 = { class: "flex align-items-center" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "child-unknown",
  class: "ml-2"
}, "その他", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("生年月日 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_30 = { class: "grid flex-wrap birthday-wrap" }
const _hoisted_31 = { class: "col-4" }
const _hoisted_32 = { class: "flex align-items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年", -1))
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = { class: "flex align-items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月", -1))
const _hoisted_37 = { class: "col-4" }
const _hoisted_38 = { class: "flex align-items-center" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, "お店に伝えたいこと", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "保護者の情報")
], -1))
const _hoisted_42 = { class: "grid" }
const _hoisted_43 = { class: "col-6" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("姓 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_45 = { class: "col-6" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("名 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("メールアドレス "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_48 = {
  id: "parent-email-error",
  class: "p-error"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("電話番号 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（郵便番号） "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_51 = { class: "grid" }
const _hoisted_52 = { class: "col-6" }
const _hoisted_53 = { class: "col-6" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（都道府県・市区町村・丁目）"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("住所（番地・建物）"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("生年月日 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_57 = { class: "grid flex-wrap birthday-wrap" }
const _hoisted_58 = { class: "col-4" }
const _hoisted_59 = { class: "flex align-items-center" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "年", -1))
const _hoisted_61 = { class: "col-4" }
const _hoisted_62 = { class: "flex align-items-center" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "月", -1))
const _hoisted_64 = { class: "col-4" }
const _hoisted_65 = { class: "flex align-items-center" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "日", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-3" }, [
  /*#__PURE__*/_createTextVNode("性別 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-4 required-label" }, "必須")
], -1))
const _hoisted_68 = { class: "flex flex-wrap gap-3" }
const _hoisted_69 = { class: "flex align-items-center" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "parent-gender-male",
  class: "ml-2"
}, "男性", -1))
const _hoisted_71 = { class: "flex align-items-center" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "parent-gender-female",
  class: "ml-2"
}, "女性", -1))
const _hoisted_73 = { class: "flex align-items-center" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "parent-gender-unknown",
  class: "ml-2"
}, "その他", -1))
const _hoisted_75 = { class: "controller-wrapper" }

import { onBeforeMount, ref, computed, Ref } from "vue";
import { useStore } from "vuex";

// PrimeVueコンポーネント
import RadioButton from "primevue/radiobutton";
import Textarea from "primevue/textarea";
import Dropdown from "primevue/dropdown";

// アプリ内共通ユーティリティ・定数
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "../constants/router.constants";
import ValidateBookingSteps from "../validates/validate.booking.steps";
import ApiRouterConstants from "@/common/constants/api.router.constants";

// ユーティリティ・定数
import moment from "moment";
import axios from "axios/index";
import { get, set } from "@vueuse/core";

// Vuexストアの取得

export default /*#__PURE__*/_defineComponent({
  __name: 'ChildBookingInfo',
  setup(__props) {

/**
 * 子供予約情報入力画面のロジック
 *
 * - お子様の情報と保護者の情報を入力
 * - バリデーションとフォーム送信処理
 * - Vuexに情報を保存し、確認画面へ遷移する
 */

// Vue Core機能
const store = useStore();

/**
 * 選択されたお子様
 */
const selectedChild = ref(null);

/**
 * お子様選択肢のリスト
 */
const childOptions = ref([{ value: "new", label: "お子様の情報を登録する" }]);

/**
 * お子様の情報を格納する reactive オブジェクト
 */
let childInfo = ref({
  firstName: "",
  lastName: "",
  firstNameKana: "",
  lastNameKana: "",
  gender: "male",
  birthday: "",
  note: "",
  noteSymptom: "",
});

/**
 * 保護者の情報を格納する reactive オブジェクト
 */
let parentInfo = ref({
  firstName: "",
  lastName: "",
  firstNameKana: "",
  lastNameKana: "",
  gender: "male",
  birthday: "",
  tel: "",
  email: "",
  address: "",
  zipcode: "",
  addressNumber: "",
});

/**
 * お子様の生年月日ドロップダウン選択用の reactive オブジェクト
 */
const childBirthday = ref({
  date: "",
  month: "",
  year: "",
});

/**
 * 保護者の生年月日ドロップダウン選択用の reactive オブジェクト
 */
const parentBirthday = ref({
  date: "",
  month: "",
  year: "",
});

/** 生年月日の「年」選択肢リスト */
const yearsList = ref<string[]>([]);

/** 生年月日の「月」選択肢リスト（1〜12固定） */
const monthsList = ref<string[]>(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]);

/** お子様の名（firstName）のバリデーションエラーメッセージ */
const childFirstNameErrorMessage = ref<string>("");

/** お子様の姓（lastName）のバリデーションエラーメッセージ */
const childLastNameErrorMessage = ref<string>("");

/** お子様の名（かな）のバリデーションエラーメッセージ */
const childFirstNameKanaErrorMessage = ref<string>("");

/** お子様の姓（かな）のバリデーションエラーメッセージ */
const childLastNameKanaErrorMessage = ref<string>("");

/** 保護者の名（firstName）のバリデーションエラーメッセージ */
const parentFirstNameErrorMessage = ref<string>("");

/** 保護者の姓（lastName）のバリデーションエラーメッセージ */
const parentLastNameErrorMessage = ref<string>("");

/** 保護者の名（かな）のバリデーションエラーメッセージ */
const parentFirstNameKanaErrorMessage = ref<string>("");

/** 保護者の姓（かな）のバリデーションエラーメッセージ */
const parentLastNameKanaErrorMessage = ref<string>("");

/** 保護者のメールアドレスのバリデーションエラーメッセージ */
const parentEmailErrorMessage = ref<string>("");

/**
 * お子様の生年月日の「日」選択肢リストを月・年から動的に計算
 */
const getChildDaysList = computed(() => {
  const days = new Date(Number(childBirthday.value.year), Number(childBirthday.value.month), 0).getDate();
  let dayList = [];
  for (let i = 1; i <= days; i++) {
    dayList.push(i);
  }
  return dayList.map(String);
});

/**
 * 保護者の生年月日の「日」選択肢リストを月・年から動的に計算
 */
const getParentDaysList = computed(() => {
  const days = new Date(Number(parentBirthday.value.year), Number(parentBirthday.value.month), 0).getDate();
  let dayList = [];
  for (let i = 1; i <= days; i++) {
    dayList.push(i);
  }
  return dayList.map(String);
});

/**
 * 郵便番号のバリデーション：正しい形式（7桁または3桁-4桁）かどうかを判定
 *
 * @returns {boolean} true の場合は「有効な郵便番号」
 */
const isValidZipcode = computed(() => {
  const zipcode = parentInfo.value.zipcode || "";
  return /^(?:\d{7}|\d{3}-\d{4})$/.test(zipcode);
});

/**
 * 生年月日の「年」選択肢を 1900〜現在年 まで生成する
 */
const getYearsList = () => {
  const startYear = 1900;
  const endYear = new Date().getFullYear();
  for (let i = endYear; i >= startYear; i--) {
    yearsList.value = [...yearsList.value, i.toString()];
  }
};

/**
 * お子様選択変更時の処理
 */
const onChildSelectionChange = () => {
  if (!selectedChild.value) {
    // 選択がクリアされた場合は情報をリセット
    resetChildInfo();
    store.commit("booking/setSelectedChildId", null);
    return;
  }

  const selected = selectedChild.value as any;
  const selectedValue = selected.value;

  if (selectedValue === "new") {
    // 新規登録の場合は情報をリセット
    resetChildInfo();
    store.commit("booking/setSelectedChildId", null);
    return;
  }

  // 既存の子どもを選択した場合
  if (selected.data) {
    const child = selected.data;

    // 名前を分割（"姓 名" 形式）
    const nameArray = (child.name || "").split(" ");
    const lastName = nameArray[0] || "";
    const firstName = nameArray.slice(1).join(" ") || "";

    // 名前（かな）を分割（"姓 名" 形式）
    const nameKanaArray = (child.name_kana || "").split(" ");
    const lastNameKana = nameKanaArray[0] || "";
    const firstNameKana = nameKanaArray.slice(1).join(" ") || "";

    // 子ども情報をフォームにセット
    setChildInfo({
      firstName,
      lastName,
      firstNameKana,
      lastNameKana,
      gender: child.gender || "male",
      birthday: child.birthday || "",
      note: "",
      noteSymptom: "",
    });

    // 選択された子どものIDをVuexストアに保存
    store.commit("booking/setSelectedChildId", child.id);
  }
};

/**
 * お子様の情報をセットする
 */
const setChildInfo = (info: {
  firstName: string;
  lastName: string;
  firstNameKana: string;
  lastNameKana: string;
  gender: string;
  birthday: string;
  note: string;
  noteSymptom: string;
}) => {
  childInfo.value = { ...info };

  // 生年月日をパースしてドロップダウンにセット
  if (info.birthday) {
    const date = moment(info.birthday);
    childBirthday.value.year = date.format("YYYY");
    childBirthday.value.month = date.format("M");
    childBirthday.value.date = date.format("D");
  }
};

/**
 * お子様の情報をリセットする
 */
const resetChildInfo = () => {
  childInfo.value = {
    firstName: "",
    lastName: "",
    firstNameKana: "",
    lastNameKana: "",
    gender: "male",
    birthday: "",
    note: "",
    noteSymptom: "",
  };
  childBirthday.value = {
    date: "",
    month: "",
    year: "",
  };
};

/**
 * 入力チェック：すべての必須項目が正しく入力されているかを判定
 */
const disableSubmitButton = computed(() => {
  // お子様の情報の必須項目チェック
  const childRequiredFields = [
    childInfo.value.firstName,
    childInfo.value.lastName,
    childInfo.value.firstNameKana,
    childInfo.value.lastNameKana,
    childInfo.value.gender,
    childBirthday.value.year,
    childBirthday.value.month,
    childBirthday.value.date,
  ];

  // 保護者の情報の必須項目チェック
  const parentRequiredFields = [
    parentInfo.value.firstName,
    parentInfo.value.lastName,
    parentInfo.value.gender,
    parentBirthday.value.year,
    parentBirthday.value.month,
    parentBirthday.value.date,
    parentInfo.value.tel,
    parentInfo.value.email,
    parentInfo.value.zipcode,
    parentInfo.value.address,
    parentInfo.value.addressNumber,
  ];

  // 空白文字のみのチェック
  const hasWhitespaceOnly = (value: string) => {
    return value.trim() === "" && value !== "";
  };

  // お子様の情報で空白文字のみの項目があるかチェック
  const childHasWhitespaceOnly = childRequiredFields.some(hasWhitespaceOnly);
  // 保護者の情報で空白文字のみの項目があるかチェック
  const parentHasWhitespaceOnly = parentRequiredFields.some(hasWhitespaceOnly);

  // 必須項目が未入力または空白文字のみの場合、ボタンを無効化
  return (
    childRequiredFields.some(field => !field || field.trim() === "") ||
    parentRequiredFields.some(field => !field || field.trim() === "") ||
    childHasWhitespaceOnly ||
    parentHasWhitespaceOnly
  );
});

/**
 * 「次へ」ボタン押下時の処理
 */
const accept = () => {
  // お子様の名前の空白チェック
  if (checkWhitespace(childInfo.value.firstName || "", childFirstNameErrorMessage, "child-first-name-error")) {
    return;
  }
  if (checkWhitespace(childInfo.value.lastName || "", childLastNameErrorMessage, "child-last-name-error")) {
    return;
  }
  if (
    checkWhitespace(childInfo.value.firstNameKana || "", childFirstNameKanaErrorMessage, "child-first-name-kana-error")
  ) {
    return;
  }
  if (
    checkWhitespace(childInfo.value.lastNameKana || "", childLastNameKanaErrorMessage, "child-last-name-kana-error")
  ) {
    return;
  }

  // 保護者の名前の空白チェック
  if (checkWhitespace(parentInfo.value.firstName || "", parentFirstNameErrorMessage, "parent-first-name-error")) {
    return;
  }
  if (checkWhitespace(parentInfo.value.lastName || "", parentLastNameErrorMessage, "parent-last-name-error")) {
    return;
  }

  // メールアドレスのバリデーション
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  parentEmailErrorMessage.value = "";
  if (!emailRegex.test(parentInfo.value.email || "")) {
    parentEmailErrorMessage.value = "メールアドレスの形式が正しくありません";
    document.getElementById("parent-email-error")?.scrollIntoView();
    return;
  }

  // 生年月日を整形
  childInfo.value.birthday = `${childBirthday.value.year}/${childBirthday.value.month}/${childBirthday.value.date}`;
  parentInfo.value.birthday = `${parentBirthday.value.year}/${parentBirthday.value.month}/${parentBirthday.value.date}`;

  // お子様の生年月日を結合
  const childBirthdayString = `${childBirthday.value.year}/${childBirthday.value.month}/${childBirthday.value.date}`;
  const parentBirthdayString = `${parentBirthday.value.year}/${parentBirthday.value.month}/${parentBirthday.value.date}`;

  // 子ども予約フラグを設定
  store.commit("booking/setIsChildBooking", true);

  // お子様の情報をVuexストアに保存
  store.commit("booking/setChildInfo", {
    firstName: childInfo.value.firstName,
    lastName: childInfo.value.lastName,
    firstNameKana: childInfo.value.firstNameKana,
    lastNameKana: childInfo.value.lastNameKana,
    gender: childInfo.value.gender,
    birthday: childBirthdayString,
    note: childInfo.value.note,
    noteSymptom: childInfo.value.noteSymptom,
  });

  // 保護者の情報をVuexストアに保存
  store.commit("booking/setParentInfo", {
    firstName: parentInfo.value.firstName,
    lastName: parentInfo.value.lastName,
    gender: parentInfo.value.gender,
    birthday: parentBirthdayString,
    tel: parentInfo.value.tel,
    email: parentInfo.value.email,
    zipcode: parentInfo.value.zipcode,
    address: parentInfo.value.address,
    addressNumber: parentInfo.value.addressNumber,
  });

  // 内容確認画面に遷移
  RouterUtils.goTo(RouterConstants.CONTENT_CONFIRMATION_ROUTER_NAME);
};

/**
 * 名前入力欄の空白チェックユーティリティ
 */
const checkWhitespace = (value: string, errorMessage: Ref<string>, errorElementId: string) => {
  const stringHasWhitespaceRegex = /\s/;
  errorMessage.value = "";
  if (stringHasWhitespaceRegex.test(value)) {
    errorMessage.value = "名前にスペースは使用できません。";
    document.getElementById(errorElementId)?.scrollIntoView();
    return true;
  }
  return false;
};

/**
 * 郵便番号から住所を検索する
 *
 * @function searchAddress
 * @returns {Promise<void>}
 */
const searchAddress = async () => {
  if (!isValidZipcode.value) {
    return; // 郵便番号が無効な場合は何もしない
  }

  try {
    // 郵便番号を7桁の数字に正規化
    const normalizedZipcode = parentInfo.value.zipcode?.replace(/-/g, "") || "";

    // 郵便番号検索APIを呼び出し
    const response = await axios.get(`https://zipcloud.ibsnet.co.jp/api/search`, {
      params: {
        zipcode: normalizedZipcode,
      },
    });

    if (response.data && response.data.results && response.data.results.length > 0) {
      const addressData = response.data.results[0];
      // 住所を組み立てて設定
      const fullAddress = `${addressData.address1}${addressData.address2}${addressData.address3}`;
      parentInfo.value.address = fullAddress;
    }
  } catch (error) {
    console.log("住所検索に失敗しました:", error);
    // エラーが発生した場合は何もしない（既存の入力は保持）
  }
};

/**
 * 「戻る」ボタン押下時の処理（個人情報入力画面に戻る）
 */
const back = () => {
  RouterUtils.goTo(RouterConstants.PERSONAL_INFO_ROUTER_NAME);
};

/**
 * 編集モードの場合、予約に紐づく子ども情報を復元
 */
const restoreChildInfoIfEdit = () => {
  const customerId = store.getters["booking/customerId"];

  // customerId が存在しない場合は新規予約
  if (!customerId) return;

  // 子ども一覧から customer_id に一致する子どもを検索
  const targetChild = childOptions.value.find(option => option.value === customerId);

  if (targetChild && targetChild.data) {
    // ドロップダウンで該当の子どもを選択状態にする
    selectedChild.value = targetChild;

    // 子ども情報をフォームにセット
    onChildSelectionChange();

    // 予約編集時: Vuexに保存された note_symptom を復元
    const savedNoteSymptom = store.getters["booking/customerInfo"].noteSymptom;
    if (savedNoteSymptom) {
      childInfo.value.noteSymptom = savedNoteSymptom;
    }
  }
};

/**
 * コンポーネントマウント前に実行する初期化処理
 */
onBeforeMount(async () => {
  // 年リスト初期化
  getYearsList();

  // 既存顧客情報の読み込み（親情報）
  await fetchExistingCustomerInfo();

  // 子ども一覧の取得
  await fetchChildrenList();

  // 編集モードの場合、既存の子ども情報を復元
  restoreChildInfoIfEdit();

  // ステップバリデーション
  ValidateBookingSteps();
});

/**
 * 既存顧客情報を取得して保護者情報フォームに自動入力
 */
const fetchExistingCustomerInfo = async () => {
  try {
    // APIから顧客情報を取得
    const response = await axios.get(`${ApiRouterConstants.API_CUSTOMERS}/info`, {
      params: {
        clinic_id: store.getters["line_account/clinicId"],
        line_account_id: store.getters["line_account/id"],
      },
      headers: { Accept: "application/json" },
    });

    if (response.data) {
      const customerData = response.data;

      // 名前を分割（"姓 名" 形式）
      const nameArray = (customerData.name || "").split(" ");
      const lastName = nameArray[0];
      const firstName = nameArray.slice(1).join(" ");

      // 保護者情報に既存顧客情報をセット
      set(parentInfo.value, "firstName", firstName);
      set(parentInfo.value, "lastName", lastName);
      set(parentInfo.value, "tel", customerData.phone || "");
      set(parentInfo.value, "email", customerData.email || "");
      set(parentInfo.value, "zipcode", customerData.zipcode || "");
      set(parentInfo.value, "address", customerData.address || "");
      set(parentInfo.value, "addressNumber", customerData.address_number || "");
      set(parentInfo.value, "gender", customerData.gender || "male");

      // 生年月日をパースしてドロップダウンにセット
      if (customerData.birthday) {
        const birthdayMoment = moment(customerData.birthday);
        set(parentBirthday.value, "year", birthdayMoment.format("YYYY"));
        set(parentBirthday.value, "month", birthdayMoment.format("M"));
        set(parentBirthday.value, "date", birthdayMoment.format("D"));
      }
    }
  } catch (error) {
    console.log("顧客情報の取得に失敗しました:", error);
    // エラーの場合は空のフォームのまま（新規入力として扱う）
  }
};

/**
 * 子ども一覧を取得してドロップダウンに追加
 */
const fetchChildrenList = async () => {
  try {
    const response = await axios.get(`${ApiRouterConstants.API_CUSTOMERS}/children`, {
      params: {
        clinic_id: store.getters["line_account/clinicId"],
        line_account_id: store.getters["line_account/id"],
      },
      headers: { Accept: "application/json" },
    });

    if (response.data && response.data.length > 0) {
      // APIから取得した子どもを選択肢に追加
      const children = response.data.map((child: any) => ({
        value: child.id,
        label: child.name,
        data: child,
      }));

      childOptions.value = [{ value: "new", label: "お子様の情報を登録する" }, ...children];
    }
  } catch (error) {
    console.error("子ども一覧の取得に失敗しました:", error);
    // エラーの場合は新規登録のみ可能
  }
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _directive_text_format = _resolveDirective("text-format")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(Dropdown), {
          modelValue: selectedChild.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedChild).value = $event)),
          options: childOptions.value,
          optionLabel: "label",
          placeholder: "新しくお子様を登録する",
          class: "w-full input-text",
          onChange: onChildSelectionChange
        }, null, 8, ["modelValue", "options"])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputText, {
            class: "input-text",
            modelValue: _unref(childInfo).lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(childInfo).lastName) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", _hoisted_10, _toDisplayString(childFirstNameErrorMessage.value), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createVNode(_component_InputText, {
            class: "input-text",
            modelValue: _unref(childInfo).firstName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(childInfo).firstName) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", _hoisted_13, _toDisplayString(childLastNameErrorMessage.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_InputText, {
            class: "input-text",
            modelValue: _unref(childInfo).lastNameKana,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(childInfo).lastNameKana) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", _hoisted_17, _toDisplayString(childFirstNameKanaErrorMessage.value), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_InputText, {
            class: "input-text",
            modelValue: _unref(childInfo).firstNameKana,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(childInfo).firstNameKana) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("small", _hoisted_20, _toDisplayString(childLastNameKanaErrorMessage.value), 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(childInfo).gender,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(childInfo).gender) = $event)),
              inputId: "child-male",
              name: "child-gender",
              value: "male"
            }, null, 8, ["modelValue"]),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(childInfo).gender,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(childInfo).gender) = $event)),
              inputId: "child-female",
              name: "child-gender",
              value: "female"
            }, null, 8, ["modelValue"]),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(childInfo).gender,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(childInfo).gender) = $event)),
              inputId: "child-unknown",
              name: "child-gender",
              value: "unknown"
            }, null, 8, ["modelValue"]),
            _hoisted_28
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_unref(Dropdown), {
                modelValue: childBirthday.value.year,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((childBirthday.value.year) = $event)),
                options: yearsList.value,
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_33
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(_unref(Dropdown), {
                modelValue: childBirthday.value.month,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((childBirthday.value.month) = $event)),
                options: monthsList.value,
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_36
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createVNode(_unref(Dropdown), {
                modelValue: childBirthday.value.date,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((childBirthday.value.date) = $event)),
                options: _unref(getChildDaysList),
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_39
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_40,
        _createVNode(_unref(Textarea), {
          class: "input-text others",
          rows: "5",
          modelValue: _unref(childInfo).noteSymptom,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(childInfo).noteSymptom) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _hoisted_41,
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode(_component_InputText, {
            modelValue: _unref(parentInfo).lastName,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(parentInfo).lastName) = $event)),
            class: "input-text"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createVNode(_component_InputText, {
            modelValue: _unref(parentInfo).firstName,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(parentInfo).firstName) = $event)),
            class: "input-text"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_47,
        _createVNode(_component_InputText, {
          modelValue: _unref(parentInfo).email,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(parentInfo).email) = $event)),
          class: "input-text",
          inputmode: "email",
          type: "email"
        }, null, 8, ["modelValue"]),
        _createElementVNode("small", _hoisted_48, _toDisplayString(parentEmailErrorMessage.value), 1)
      ]),
      _createElementVNode("div", null, [
        _hoisted_49,
        _createVNode(_component_InputText, {
          modelValue: _unref(parentInfo).tel,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(parentInfo).tel) = $event)),
          class: "input-text",
          inputmode: "numeric"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _withDirectives(_createVNode(_component_InputText, {
              modelValue: _unref(parentInfo).zipcode,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(parentInfo).zipcode) = $event)),
              class: "input-text"
            }, null, 8, ["modelValue"]), [
              [_directive_text_format, /\d|-/]
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createVNode(_component_Button, {
              class: "address-search-btn",
              onClick: searchAddress,
              disabled: !_unref(isValidZipcode)
            }, {
              default: _withCtx(() => [
                _createTextVNode("住所検索")
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_54,
        _createVNode(_component_InputText, {
          modelValue: _unref(parentInfo).address,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(parentInfo).address) = $event)),
          class: "input-text"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_55,
        _createVNode(_component_InputText, {
          modelValue: _unref(parentInfo).addressNumber,
          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(parentInfo).addressNumber) = $event)),
          class: "input-text"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", null, [
        _hoisted_56,
        _createElementVNode("div", _hoisted_57, [
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _createVNode(_unref(Dropdown), {
                modelValue: parentBirthday.value.year,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((parentBirthday.value.year) = $event)),
                options: yearsList.value,
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_60
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createVNode(_unref(Dropdown), {
                modelValue: parentBirthday.value.month,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((parentBirthday.value.month) = $event)),
                options: monthsList.value,
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_63
            ])
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_unref(Dropdown), {
                modelValue: parentBirthday.value.date,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((parentBirthday.value.date) = $event)),
                options: _unref(getParentDaysList),
                class: "w-full input-text mr-2"
              }, null, 8, ["modelValue", "options"]),
              _hoisted_66
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_67,
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(parentInfo).gender,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(parentInfo).gender) = $event)),
              value: "male",
              inputId: "parent-gender-male"
            }, null, 8, ["modelValue"]),
            _hoisted_70
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(parentInfo).gender,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(parentInfo).gender) = $event)),
              value: "female",
              inputId: "parent-gender-female"
            }, null, 8, ["modelValue"]),
            _hoisted_72
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(parentInfo).gender,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(parentInfo).gender) = $event)),
              value: "unknown",
              inputId: "parent-gender-unknown"
            }, null, 8, ["modelValue"]),
            _hoisted_74
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_75, [
      _createVNode(_component_Button, {
        class: "btn cancel-btn w-full",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("戻る")
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn accept-btn w-full",
        onClick: accept,
        disabled: _unref(disableSubmitButton)
      }, {
        default: _withCtx(() => [
          _createTextVNode("次へ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})